import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndpoint';
import { SuperloginService } from '../superlogin/superlogin.service';

@Injectable({
  providedIn: 'root'
})
export class RetrievefeesitemService {

  constructor(
    private http: HttpClient,
    private urls: UrlSignature,
    private authService: SuperloginService
  ) {}

  // 🔐 Token header (same pattern as your working services)
  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken() || '';
    return new HttpHeaders({
      Authorization: 'Bearer ' + token
    });
  }

  // 🎯 GET with query params
  getByScope(
    studentType: string,
    academicYear: string,
    semester: string
  ): Observable<any[]> {

    const params = new HttpParams()
      .set('studentType', studentType)
      .set('academicYear', academicYear)
      .set('semester', semester);

    return this.http.get<any[]>(
      this.urls.retrievefeesitemsurl, // ✅ using your correct endpoint
      {
        headers: this.getHeaders(),
        params
      }
    );
  }
}